// // Enhanced Slider Initialization - FAST VERSION
// (function() {
//   'use strict';
  
//   // ========== 1. MAIN INITIALIZATION ==========
//   document.addEventListener('DOMContentLoaded', function() {
//     // Initialize immediately
//     // setTimeout(initializeSliders, 100); // Small delay to ensure DOM is ready
//   });
  
//   // Initialize on page load
//   window.addEventListener('load', initializeSliders);
//   let resizeTimer;

// window.addEventListener('resize', () => {
//   clearTimeout(resizeTimer);
//   resizeTimer = setTimeout(() => {
//     initializeSliders();
//   }, 200); // delay in ms (adjust as needed)
// });

  
//   // Initialize on Shopify section events
//   if (typeof window.Shopify !== 'undefined') {
//     // document.addEventListener('shopify:section:load', initializeSliders);
//     document.addEventListener('shopify:section:unload', function() {
//       // setTimeout(initializeSliders, 50);
//     });
//   }
  
//   // ========== 2. CORE SLIDER FUNCTIONS ==========
//   function initializeSliders() {
//     //  console.log("Resize===");
     
//     // Enhanced Collection Slider (MAIN)
//     if (document.querySelector('.custom-col-enhanced-slider')) {
//       setTimeout(() => {
//         initEnhancedCollectionSlider();
//       }, 1000);
      
//     }
    
//     // Custom Enhanced Slider
//     if (document.querySelector('.custom-enhanced-slider')) {
//       initCustomEnhancedSlider();
//     }
    
//     // Key Ingredients Slider
//     if (document.querySelector('.key-ingredients-slider')) {
//       initKeyIngredientsSlider();
//     }
//   }
  
//   function initEnhancedCollectionSlider() {
 
//     // const slider = document.querySelector('.custom-col-enhanced-slider');
//     //  console.log("slidere===")
//     // if (!slider) return;
//     // let show_slider=true;
//     // if (window.innerWidth<=749) {
//     //   show_slider=false;
//     //   if ($(slider).hasClass("enhanced-mobile")) {
//     //     show_slider=true;
//     //   }
//     //   else{
//     //     show_slider=false;
//     //   }
//     // }
//     // console.log("Show Slider---",show_slider);
    
//     //  if (slider.classList.contains('slick-initialized')) {
//     //   $('.custom-col-enhanced-slider').slick("unslick")
//     // }
//     // Check if already initialized
//     // if (slider.classList.contains('slick-initialized')) {
//     //   // return;
//     // }
    
//     // Check if products exist
//     // const products = slider.querySelectorAll('.card.product-card');
//     // if (products.length === 0) {
//       // Try again after delay
//       // setTimeout(initEnhancedCollectionSlider, 300);
//       // return;
//     // }
    
//     // console.log('Initializing Enhanced Collection Slider with', products.length, 'products');
    
//     // Destroy any existing instance
//     // if (window.jQuery && $(slider).hasClass('slick-initialized')) {
//     //   $(slider).slick('unslick');
//     // }
    
//     // Initialize with jQuery
//     // if (window.jQuery && typeof $.fn.slick !== 'undefined') {
//    if (window.jQuery && typeof $.fn.slick !== 'undefined') {
//   // console.log("Initialize 1===", show_slider);
//      if (window.innerWidth<=749) {
//       initEnhancedMobileOnly()
//     }
//     else{
//        $('.enhanced-mobile-only').each(function (item,i) {
//     if ($(this).hasClass('slick-initialized')) {
//         $(this).slick("unslick");
//       }
//        });
//        console.log("Exit 1====");
       
//        return;
//       }
//       console.log("Exit 2====");

//   $('.custom-col-enhanced-slider').each(function (item,i) {
//     if ($(this).hasClass('slick-initialized')) {
//         $(this).slick("unslick");
//       }
//      let show_slider=true;
//     if (window.innerWidth<=749) {
//       show_slider=false;
//       if ($(this).hasClass("enhanced-mobile")) {
//         show_slider=true;
//       }
//       else{
//         show_slider=false;
//       }
//     }
//     const $slider = $(this);

//     // Prevent double init

    
//     console.log("Show slider====",show_slider,"==",item);
//     if (!show_slider) {
//       console.log("Initial====",$slider.hasClass('slick-initialized'));
      
//       if ($slider.hasClass('slick-initialized')) {
//         $slider.slick("unslick");
//         console.log("Uninitialized===");
        
//       }
//       return;
//     }

//     // if ($slider.hasClass('slick-initialized')) return;

//     if (!$slider.hasClass('slick-initialized')) {
//   console.log(show_slider,"=====");

//   $slider.slick({
//       centerMode: false,
//       centerPadding: '0',
//       infinite: true,
//       arrows: true,
//       mobileFirst: true,
//       dots: true,
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       speed: 300,
//       autoplay: false,
//       prevArrow:
//         '<button type="button" class="slick-prev" aria-label="Previous">' +
//         '<svg class="icon icon-chevron-left icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none">' +
//         '<path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path>' +
//         '</svg></button>',
//       nextArrow:
//         '<button type="button" class="slick-next" aria-label="Next">' +
//         '<svg class="icon icon-chevron-right icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none">' +
//         '<path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path>' +
//         '</svg></button>',
//       responsive: [
//         {
//           breakpoint: 749,
//           settings: {
//             slidesToShow: 3
//           }
//         },
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 4
//           }
//         },
//         {
//           breakpoint: 1200,
//           settings: {
//             slidesToShow: 4
//           }
//         }
//       ]
//     });
//  }
    
//   });
// }

//   }
console.log("Custom js-----");

  function initEnhancedMobileOnly() {
    if (window.jQuery && typeof $.fn.slick !== 'undefined') {
  console.log("Initialize mobile 1===");

  $('.enhanced-mobile-only').not(".custom-col-enhanced-slider").each(function (item,i) {
    if ($(this).hasClass('slick-initialized')) {
        $(this).slick("unslick");
      }
    
    const $slider = $(this);
    // Prevent double init

    
    // console.log("Show slider====",show_slider,"==",item);
    // if (!show_slider) {
    //   console.log("Initial====",$slider.hasClass('slick-initialized'));
      
    //   if ($slider.hasClass('slick-initialized')) {
    //     $slider.slick("unslick");
    //     console.log("Uninitialized===");
        
    //   }
    //   return;
    // }

    // if ($slider.hasClass('slick-initialized')) return;

    if (!$slider.hasClass('slick-initialized')) {
  // console.log(show_slider,"=====");

  $slider.slick({
      centerMode: false,
      centerPadding: '0',
      infinite: true,
      arrows: true,
      mobileFirst: true,
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 300,
      autoplay: false,
      prevArrow:
        '<button type="button" class="slick-prev" aria-label="Previous">' +
        '<svg class="icon icon-chevron-left icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path>' +
        '</svg></button>',
      nextArrow:
        '<button type="button" class="slick-next" aria-label="Next">' +
        '<svg class="icon icon-chevron-right icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path>' +
        '</svg></button>',
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          }
        }
      ]
    });
 }
    
  });
}
  }
  
//   function initCustomEnhancedSlider() {
//     const slider = document.querySelector('.custom-enhanced-slider');
//     if (!slider) return;
    
//     if (slider.classList.contains('slick-initialized')) return;
    
//     if (window.jQuery && typeof $.fn.slick !== 'undefined') {
//       console.log("Initialize 2===");

//       $(slider).slick({
//         centerMode: true,
//         centerPadding: '30px',
//         arrows: true,
//         mobileFirst: true,
//         dots: true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         prevArrow: '<button class="slick-prev"><svg class="icon icon-chevron-left icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path></svg></button>',
//         nextArrow: '<button class="slick-next"><svg class="icon icon-chevron-right icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path></svg></button>',
//         responsive: [
//           {
//             breakpoint: 749,
//             settings: {
//               slidesToShow: 3,
//               slidesToScroll: 1
//             }
//           },
//           {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 4,
//               slidesToScroll: 1
//             }
//           },
//           {
//             breakpoint: 1200,
//             settings: {
//               slidesToShow: 4,
//               slidesToScroll: 1
//             }
//           }
//         ]
//       });
//     }
//   }
  
//   function initKeyIngredientsSlider() {
//     const slider = document.querySelector('.key-ingredients-slider');
//     if (!slider) return;
    
//     if (slider.classList.contains('slick-initialized')) return;
    
//     if (window.jQuery && typeof $.fn.slick !== 'undefined') {
//       console.log("Initialize 3===");

//       $(slider).slick({
//         arrows: true,
//         mobileFirst: true,
//         centerMode: true,
//         centerPadding: '30px',
//         dots: true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         prevArrow: '<button class="slick-prev"><svg class="icon icon-chevron-left icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path></svg></button>',
//         nextArrow: '<button class="slick-next"><svg class="icon icon-chevron-right icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path></svg></button>',
//         responsive: [
//           {
//             breakpoint: 575,
//             settings: {
//               slidesToShow: 2,
//               dots: false
//             }
//           },
//           {
//             breakpoint: 749,
//             settings: {
//               slidesToShow: 3,
//               centerMode: false,
//               dots: false
//             }
//           },
//           {
//             breakpoint: 1025,
//             settings: {
//               slidesToShow: 4,
//               centerMode: false,
//               dots: false
//             }
//           },
//           {
//             breakpoint: 1237,
//             settings: {
//               slidesToShow: 5,
//               centerMode: false,
//               dots: false
//             }
//           }
//         ]
//       });
//     }
//   }
  
//   // ========== 3. QUICK VIEW & ADD TO CART ==========
//   document.addEventListener('click', function(e) {
//     // Quick View Button
//     if (e.target.closest('.quick-view__button') || e.target.closest('.product-card__quick-view')) {
//       e.preventDefault();
//       const button = e.target.closest('.quick-view__button') || e.target.closest('.product-card__quick-view');
//       const productCard = button.closest('.product-card');
//       const quickViewEl = productCard.querySelector('.quick-view');
      
//       if (quickViewEl) {
//         const productUrl = quickViewEl.getAttribute('data-product-url');
//         const quickViewModal = document.querySelector(`quick-view[data-product-url="${productUrl}"]`);
        
//         if (quickViewModal && typeof quickViewModal.show === 'function') {
//           quickViewModal.show();
//         }
//       }
//     }
    
//     // Add to Cart Button in Quick View
//     if (e.target.closest('.product-form__submit.button') || 
//         (e.target.type === 'submit' && e.target.closest('.product-form__buttons'))) {
//       e.preventDefault();
      
//       const formButtons = e.target.closest('.product-form__buttons');
//       if (!formButtons) return;
      
//       const quantityInput = formButtons.querySelector('.quantity__input');
//       if (!quantityInput) return;
      
//       let quantity = parseInt(quantityInput.value);
//       if (isNaN(quantity) || quantity <= 0) {
//         quantity = 1;
//         quantityInput.value = quantity;
//       }
      
//       const variantId = quantityInput.getAttribute('data-quantity-variant-id');
      
//       if (variantId) {
//         // Show loading state
//         const btnText = formButtons.querySelector('.btn-text');
//         const btnLoaded = formButtons.querySelector('.btn-loaded');
        
//         if (btnText) btnText.style.opacity = '0';
//         if (btnLoaded) btnLoaded.style.opacity = '1';
        
//         // Add to cart
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             id: variantId,
//             quantity: quantity
//           })
//         })
//         .then(response => response.json())
//         .then(data => {
//           // Update cart count
//           updateCartCount();
          
//           // Close modal
//           setTimeout(() => {
//             if (typeof document.dispatchEvent === 'function') {
//               document.dispatchEvent(new CustomEvent('modal:closeAll'));
//             }
            
//             // Reset button state after delay
//             setTimeout(() => {
//               if (btnText) btnText.style.opacity = '1';
//               if (btnLoaded) btnLoaded.style.opacity = '0';
//             }, 1000);
//           }, 500);
//         })
//         .catch(error => {
//           console.error('Error adding to cart:', error);
//           if (btnText) btnText.style.opacity = '1';
//           if (btnLoaded) btnLoaded.style.opacity = '0';
//         });
//       }
//     }
//   });
  
//   // Quantity Input Handler
//   document.addEventListener('input', function(e) {
//     if (e.target.classList.contains('quantity__input')) {
//       let val = parseInt(e.target.value);
//       if (isNaN(val) || val <= 0) {
//         e.target.value = 1;
//       }
//     }
//   });
  
//   // ========== 4. HELPER FUNCTIONS ==========
//   function updateCartCount() {
//     fetch('/cart.js')
//       .then(response => response.json())
//       .then(cart => {
//         const cartCounts = document.querySelectorAll('.cart-drawer-button .count, .header__cart-count');
//         cartCounts.forEach(element => {
//           if (cart.item_count > 0) {
//             element.removeAttribute('hidden');
//             element.textContent = cart.item_count;
//           } else {
//             element.setAttribute('hidden', 'true');
//           }
//         });
//       })
//       .catch(error => console.error('Error updating cart count:', error));
//   }
  
//   // ========== 5. MODAL CLOSE HANDLERS ==========
//   document.addEventListener('click', function(e) {
//     // Close modal when clicking outside
//     if (document.body.classList.contains('has-modal-open')) {
//       const drawerInner = e.target.closest('.drawer__inner');
//       if (!drawerInner) {
//         if (typeof document.dispatchEvent === 'function') {
//           document.dispatchEvent(new CustomEvent('modal:closeAll'));
//         }
//       }
//     }
    
//     // Close button
//     if (e.target.closest('.drawer__close')) {
//       e.preventDefault();
//       if (typeof document.dispatchEvent === 'function') {
//         document.dispatchEvent(new CustomEvent('modal:closeAll'));
//       }
//     }
//   });
  
//   // ========== 6. OPTIMIZATION ==========
//   // Initialize on DOM mutations (for dynamic content)
//   if (typeof MutationObserver !== 'undefined') {
//     const observer = new MutationObserver(function(mutations) {
//       mutations.forEach(function(mutation) {
//         if (mutation.addedNodes.length) {
//           // Check if enhanced slider was added
//           mutation.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) { // Element node
//               if (node.classList && node.classList.contains('custom-col-enhanced-slider')) {
//                 setTimeout(initEnhancedCollectionSlider, 100);
//               }
//               if (node.querySelector && node.querySelector('.custom-col-enhanced-slider')) {
//                 setTimeout(initEnhancedCollectionSlider, 100);
//               }
//             }
//           });
//         }
//       });
//     });
    
//     observer.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }
  
//   // Force re-initialization after a delay (fallback)
//   // setTimeout(initializeSliders, 500);
//   // setTimeout(initializeSliders, 1000);
//   // setTimeout(initializeSliders, 2000);
  
// })();

// // ========== 7. ULTRA FAST INITIALIZATION ==========
// // This runs immediately without waiting for DOMContentLoaded
// (function() {
//   // Check if jQuery and Slick are available
//   function checkDependencies() {
//     if (!window.jQuery) {
//       console.warn('jQuery not loaded');
//       return false;
//     }
//     if (typeof $.fn.slick === 'undefined') {
//       console.warn('Slick slider not loaded');
//       return false;
//     }
//     return true;
//   }
  
//   // Ultra fast initialization
//   if (checkDependencies()) {
//     // Initialize immediately if possible
//     $(function() {
//       // Enhanced Collection Slider - HIGH PRIORITY
//       const $enhancedSlider = $('.custom-col-enhanced-slider');
// //       let show_slider=true;
// //       if (window.innerWidth<=749) {
// //         show_slider=false;
// //         if ($(".custom-col-enhanced-slider.enhanced-mobile").length) {
// //           show_slider=true;
// //         }
// //         else{
// //           show_slider=false;
// // //           show_slider=false;
// // //  $enhancedSlider.slick("unslick")
// //         }
// //       }
//       if ($enhancedSlider.length && !$enhancedSlider.hasClass('slick-initialized') ) {
//         // console.log("custom-jtp=====");
        
//         const $products = $enhancedSlider.find('.card.product-card');
//         if ($products.length > 0) {
//           console.log('Ultra fast initialization of enhanced slider');
//       console.log("Initialize 4===");

//           // $enhancedSlider.slick({
//           //   centerMode: false,
//           //   centerPadding: '0',
//           //   infinite: true,
//           //   arrows: true,
//           //   mobileFirst: true,
//           //   dots: true,
//           //   slidesToShow: 2,
//           //   slidesToScroll: 1,
//           //   speed: 300,
//           //   prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg class="icon icon-chevron-left icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path></svg></button>',
//           //   nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg class="icon icon-chevron-right icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path></svg></button>',
//           //   responsive: [
//           //     {
//           //       breakpoint: 749,
//           //       settings: {
//           //         slidesToShow: 3,
//           //         slidesToScroll: 1
//           //       }
//           //     },
//           //     {
//           //       breakpoint: 1024,
//           //       settings: {
//           //         slidesToShow: 4,
//           //         slidesToScroll: 1
//           //       }
//           //     },
//           //     {
//           //       breakpoint: 1200,
//           //       settings: {
//           //         slidesToShow: 4,
//           //         slidesToScroll: 1
//           //       }
//           //     }
//           //   ]
//           // });
//         }
//       }
//     });
//   }
// })();


// Enhanced Slider Initialization - FAST VERSION
(function() {
  'use strict';
  
  // ========== 1. MAIN INITIALIZATION ==========
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize immediately
    // setTimeout(initializeSliders, 1500); // Small delay to ensure DOM is ready
  });
  
  // Initialize on page load
  window.addEventListener('load', ()=>{
    setTimeout(() => {
      initializeSliders();
    }, 100);
    
    console.log("load slide===");
    
  }
  );
  let resizeTimer;
initializeSliders();
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    initializeSliders();
  }, 200); // delay in ms (adjust as needed)
});  
  // Initialize on Shopify section events
  if (typeof window.Shopify !== 'undefined') {
    // document.addEventListener('shopify:section:load', initializeSliders);
    document.addEventListener('shopify:section:unload', function() {
      // setTimeout(initializeSliders, 50);
    });
  }
  
  // ========== 2. CORE SLIDER FUNCTIONS ==========
  function initializeSliders() {
     console.log("Resize===");
     
    // Enhanced Collection Slider (MAIN)
    console.log("jjj",$('.custom-col-enhanced-slider').length)
    console.log("jjjkkk", $('.enhanced-mobile-only').length)
    if ($('.custom-col-enhanced-slider').length || $('.enhanced-mobile-only').length ) {
      console.log("enhance=====");
      
      setTimeout(() => {
        initEnhancedCollectionSlider();
      }, 1000);
      
    }
    
    // Custom Enhanced Slider
    if (document.querySelector('.custom-enhanced-slider')) {
      initCustomEnhancedSlider();
    }
    
    // Key Ingredients Slider
    if (document.querySelector('.key-ingredients-slider')) {
      initKeyIngredientsSlider();
    }
  }
  
  function initEnhancedCollectionSlider() {
    console.log("Enhance=====");
    
    // const slider = document.querySelector('.custom-col-enhanced-slider');
    //  console.log("slidere===")
    // if (!slider) return;
    // let show_slider=true;
    // if (window.innerWidth<=749) {
    //   show_slider=false;
    //   if ($(slider).hasClass("enhanced-mobile")) {
    //     show_slider=true;
    //   }
    //   else{
    //     show_slider=false;
    //   }
    // }
    // console.log("Show Slider---",show_slider);
    
    //  if (slider.classList.contains('slick-initialized')) {
    //   $('.custom-col-enhanced-slider').slick("unslick")
    // }
    // Check if already initialized
    // if (slider.classList.contains('slick-initialized')) {
    //   // return;
    // }
    
    // Check if products exist
    // const products = slider.querySelectorAll('.card.product-card');
    // if (products.length === 0) {
      // Try again after delay
      // setTimeout(initEnhancedCollectionSlider, 300);
      // return;
    // }
    
    // console.log('Initializing Enhanced Collection Slider with', products.length, 'products');
    
    // Destroy any existing instance
    // if (window.jQuery && $(slider).hasClass('slick-initialized')) {
    //   $(slider).slick('unslick');
    // }
    
    // Initialize with jQuery
    // if (window.jQuery && typeof $.fn.slick !== 'undefined') {
   if (window.jQuery && typeof $.fn.slick !== 'undefined') {
     if (window.innerWidth<=749) {
      initEnhancedMobileOnly()
    }
    else{
      
      console.log("jjjj");
      
      $('.enhanced-mobile-only').each((i)=>{
        console.log("unslick mobile===",i);
        
  if ( $('.enhanced-mobile-only').eq(i).hasClass("slick-initialized")) {
     $('.enhanced-mobile-only').eq(i).slick("unslick")
  }
});
    }
 
  // console.log("Initialize 1===", show_slider);

  $('.custom-col-enhanced-slider').each(function (item,i) {
    if ($(this).hasClass('slick-initialized')) {
        $(this).slick("unslick");
      }
     let show_slider=true;
    if (window.innerWidth<=749) {
      show_slider=false;
      if ($(this).hasClass("enhanced-mobile")) {
        show_slider=true;
      }
      else{
        show_slider=false;
      }
    }
    const $slider = $(this);

    // Prevent double init

    
    console.log("Show slider====",show_slider,"==",item);
    if (!show_slider) {
      console.log("Initial====",$slider.hasClass('slick-initialized'));
      
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick("unslick");
        console.log("Uninitialized===");
        
      }
      return;
    }

    // if ($slider.hasClass('slick-initialized')) return;

    if (!$slider.hasClass('slick-initialized')) {
  console.log(show_slider,"=====");

  $slider.slick({
      centerMode: false,
      centerPadding: '0',
      infinite: true,
      arrows: true,
      mobileFirst: true,
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 300,
      autoplay: false,
      prevArrow:
        '<button type="button" class="slick-prev" aria-label="Previous">' +
        '<svg class="icon icon-chevron-left icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path>' +
        '</svg></button>',
      nextArrow:
        '<button type="button" class="slick-next" aria-label="Next">' +
        '<svg class="icon icon-chevron-right icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path>' +
        '</svg></button>',
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          }
        }
      ]
    });
 }
    
  });
}

  }
  
  function initCustomEnhancedSlider() {
    const slider = document.querySelector('.custom-enhanced-slider');
    // if (!slider) return;
    
    // if (slider.classList.contains('slick-initialized')) return;
    
    // if (window.jQuery && typeof $.fn.slick !== 'undefined') {
     if (!slider.classList.contains('slick-initialized')){
      console.log("Initialize 2===");

      $(slider).slick({
        centerMode: true,
        centerPadding: '30px',
        arrows: true,
        mobileFirst: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-prev"><svg class="icon icon-chevron-left icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path></svg></button>',
        nextArrow: '<button class="slick-next"><svg class="icon icon-chevron-right icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path></svg></button>',
        responsive: [
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

  }
  
  function initKeyIngredientsSlider() {
    const slider = document.querySelector('.key-ingredients-slider');
    if (!slider) return;
    
    if (slider.classList.contains('slick-initialized')) return;
    
    if (window.jQuery && typeof $.fn.slick !== 'undefined') {
      console.log("Initialize 3===");

      $(slider).slick({
        arrows: true,
        mobileFirst: true,
        centerMode: true,
        centerPadding: '30px',
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-prev"><svg class="icon icon-chevron-left icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path></svg></button>',
        nextArrow: '<button class="slick-next"><svg class="icon icon-chevron-right icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path></svg></button>',
        responsive: [
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 2,
              dots: false
            }
          },
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 3,
              centerMode: false,
              dots: false
            }
          },
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 4,
              centerMode: false,
              dots: false
            }
          },
          {
            breakpoint: 1237,
            settings: {
              slidesToShow: 5,
              centerMode: false,
              dots: false
            }
          }
        ]
      });
    }
  }
  
  // // ========== 3. QUICK VIEW & ADD TO CART ==========
  // document.addEventListener('click', function(e) {
  //   // Quick View Button
  //   if (e.target.closest('.quick-view__button') || e.target.closest('.product-card__quick-view')) {
  //     e.preventDefault();
  //     const button = e.target.closest('.quick-view__button') || e.target.closest('.product-card__quick-view');
  //     const productCard = button.closest('.product-card');
  //     const quickViewEl = productCard.querySelector('.quick-view');
      
  //     if (quickViewEl) {
  //       const productUrl = quickViewEl.getAttribute('data-product-url');
  //       const quickViewModal = document.querySelector(`quick-view[data-product-url="${productUrl}"]`);
        
  //       if (quickViewModal && typeof quickViewModal.show === 'function') {
  //         quickViewModal.show();
  //       }
  //     }
  //   }
    
  //   // Add to Cart Button in Quick View
  //   if (e.target.closest('.product-form__submit.button') || 
  //       (e.target.type === 'submit' && e.target.closest('.product-form__buttons'))) {
  //     e.preventDefault();
      
  //     const formButtons = e.target.closest('.product-form__buttons');
  //     if (!formButtons) return;
      
  //     const quantityInput = formButtons.querySelector('.quantity__input');
  //     if (!quantityInput) return;
      
  //     let quantity = parseInt(quantityInput.value);
  //     if (isNaN(quantity) || quantity <= 0) {
  //       quantity = 1;
  //       quantityInput.value = quantity;
  //     }
      
  //     const variantId = quantityInput.getAttribute('data-quantity-variant-id');
      
  //     if (variantId) {
  //       // Show loading state
  //       const btnText = formButtons.querySelector('.btn-text');
  //       const btnLoaded = formButtons.querySelector('.btn-loaded');
        
  //       if (btnText) btnText.style.opacity = '0';
  //       if (btnLoaded) btnLoaded.style.opacity = '1';
        
  //       // Add to cart
  //       fetch('/cart/add.js', {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify({
  //           id: variantId,
  //           quantity: quantity
  //         })
  //       })
  //       .then(response => response.json())
  //       .then(data => {
  //         // Update cart count
  //         updateCartCount();
          
  //         // Close modal
  //         setTimeout(() => {
  //           if (typeof document.dispatchEvent === 'function') {
  //             document.dispatchEvent(new CustomEvent('modal:closeAll'));
  //           }
            
  //           // Reset button state after delay
  //           setTimeout(() => {
  //             if (btnText) btnText.style.opacity = '1';
  //             if (btnLoaded) btnLoaded.style.opacity = '0';
  //           }, 1000);
  //         }, 500);
  //       })
  //       .catch(error => {
  //         console.error('Error adding to cart:', error);
  //         if (btnText) btnText.style.opacity = '1';
  //         if (btnLoaded) btnLoaded.style.opacity = '0';
  //       });
  //     }
  //     }
    
  // });

  
  
  // Quantity Input Handler
  document.addEventListener('input', function(e) {
    if (e.target.classList.contains('quantity__input')) {
      let val = parseInt(e.target.value);
      if (isNaN(val) || val <= 0) {
        e.target.value = 1;
      }
    }
  });
  
  // ========== 4. HELPER FUNCTIONS ==========
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCounts = document.querySelectorAll('.cart-drawer-button .count, .header__cart-count');
        cartCounts.forEach(element => {
          if (cart.item_count > 0) {
            element.removeAttribute('hidden');
            element.textContent = cart.item_count;
          } else {
            element.setAttribute('hidden', 'true');
          }
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }
  
  // ========== 5. MODAL CLOSE HANDLERS ==========
  document.addEventListener('click', function(e) {
    // Close modal when clicking outside
    if (document.body.classList.contains('has-modal-open')) {
      const drawerInner = e.target.closest('.drawer__inner');
      if (!drawerInner) {
        if (typeof document.dispatchEvent === 'function') {
          document.dispatchEvent(new CustomEvent('modal:closeAll'));
        }
      }
    }
    
    // Close button
    if (e.target.closest('.drawer__close')) {
      e.preventDefault();
      if (typeof document.dispatchEvent === 'function') {
        document.dispatchEvent(new CustomEvent('modal:closeAll'));
      }
    }
  });
  
  // ========== 6. OPTIMIZATION ==========
  // Initialize on DOM mutations (for dynamic content)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          // Check if enhanced slider was added
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && node.classList.contains('custom-col-enhanced-slider')) {
                setTimeout(initEnhancedCollectionSlider, 100);
              }
              if (node.querySelector && node.querySelector('.custom-col-enhanced-slider')) {
                setTimeout(initEnhancedCollectionSlider, 100);
              }
            }
          });
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Force re-initialization after a delay (fallback)
  // setTimeout(initializeSliders, 500);
  // setTimeout(initializeSliders, 1000);
  // setTimeout(initializeSliders, 2000);
  
})();

// ========== 7. ULTRA FAST INITIALIZATION ==========
// This runs immediately without waiting for DOMContentLoaded
(function() {
  // Check if jQuery and Slick are available
  function checkDependencies() {
    if (!window.jQuery) {
      console.warn('jQuery not loaded');
      return false;
    }
    if (typeof $.fn.slick === 'undefined') {
      console.warn('Slick slider not loaded');
      return false;
    }
    return true;
  }
  
  // Ultra fast initialization
  if (checkDependencies()) {
    // Initialize immediately if possible
    $(function() {
      // Enhanced Collection Slider - HIGH PRIORITY
      const $enhancedSlider = $('.custom-col-enhanced-slider');
//       let show_slider=true;
//       if (window.innerWidth<=749) {
//         show_slider=false;
//         if ($(".custom-col-enhanced-slider.enhanced-mobile").length) {
//           show_slider=true;
//         }
//         else{
//           show_slider=false;
// //           show_slider=false;
// //  $enhancedSlider.slick("unslick")
//         }
//       }
      if ($enhancedSlider.length && !$enhancedSlider.hasClass('slick-initialized') ) {
        // console.log("custom-jtp=====");
        
        const $products = $enhancedSlider.find('.card.product-card');
        if ($products.length > 0) {
          console.log('Ultra fast initialization of enhanced slider');
      console.log("Initialize 4===");

          // $enhancedSlider.slick({
          //   centerMode: false,
          //   centerPadding: '0',
          //   infinite: true,
          //   arrows: true,
          //   mobileFirst: true,
          //   dots: true,
          //   slidesToShow: 2,
          //   slidesToScroll: 1,
          //   speed: 300,
          //   prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg class="icon icon-chevron-left icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path></svg></button>',
          //   nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg class="icon icon-chevron-right icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path></svg></button>',
          //   responsive: [
          //     {
          //       breakpoint: 749,
          //       settings: {
          //         slidesToShow: 3,
          //         slidesToScroll: 1
          //       }
          //     },
          //     {
          //       breakpoint: 1024,
          //       settings: {
          //         slidesToShow: 4,
          //         slidesToScroll: 1
          //       }
          //     },
          //     {
          //       breakpoint: 1200,
          //       settings: {
          //         slidesToShow: 4,
          //         slidesToScroll: 1
          //       }
          //     }
          //   ]
          // });
        }
      }
    });
  }
})();


